import { ButtonIcon, Flex } from "@backstage/ui";
import { RiSendPlaneLine } from "@remixicon/react";

import styles from "./ChatInput.module.css";

export interface ChatInputProps {
    value: string;
    loading: boolean;
    onChange: (value: string) => void;
    onSend: () => void;
    inputRef: React.RefObject<HTMLTextAreaElement>;
}

export const ChatInput = ({
    value,
    loading,
    onChange,
    onSend,
    inputRef,
}: ChatInputProps) => (
    <Flex align="end" gap="1" className={styles.row}>
        <textarea
            ref={inputRef}
            value={value}
            placeholder="Type your question..."
            autoComplete="off"
            rows={1}
            className={styles.textarea}
            onChange={e => onChange(e.target.value)}
            onKeyDown={e => {
                if (e.key === "Enter" && !e.shiftKey && !loading) {
                    e.preventDefault();
                    onSend();
                }
            }}
        />
        <ButtonIcon
            icon={<RiSendPlaneLine size={18} />}
            isDisabled={loading || !value.trim()}
            aria-label="Send message"
            onPress={onSend}
            variant="tertiary"
        />
    </Flex>
);
